import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service'
import * as L from 'leaflet'
import "leaflet/dist/leaflet.css";

@Component({
  selector: 'app-data-project',
  templateUrl: './data-project.component.html',
  styleUrls: ['./data-project.component.css']
})
export class DataProjectComponent implements OnInit {

  private map: any;
  geo_province: any
  json_demo: any
  name_province: any
  get_year = [] as any
  EChartOption1: any
  EChartOption2: any
  layer_marker: any
  xAxis_1 = [] as any
  data_1 = [] as any
  data_2 = [] as any
  data_3 = [] as any
  data_4 = [] as any
  value_chart_1 = 0
  value_chart_2 = 0
  value_chart_3 = 0
  value_chart_4 = 0
  all_project: any
  type_money = ''
  name_project = ''
  select_province = ''
  budget_year = ''
  group_province: any
  group_year: any
  all_project_query = [] as any
  text_result: any
  list_province = [] as any
  list_province_2 = [] as any
  list_province_3 = [] as any
  list_province_4 = [] as any
  sum_budget: any
  sum_budget_2: any
  sum_budget_3: any
  sum_budget_4: any
  sum_project: any
  year_start: any
  year_end: any
  section = 1
  count_prov: any = 0
  user: any
  violetIcon: any
  redIcon: any
  greenIcon: any
  yelloIcon: any

  ena_projec = [] as any
  admin_data: any

  constructor(
    public services: ApiService,
    private ActivatedRoute: ActivatedRoute,
  ) {
    this.services.getYear().then((res: any) => {
      this.view_year(res)
    });


    this.violetIcon = new L.Icon({
      iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    this.redIcon = new L.Icon({
      iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    this.greenIcon = new L.Icon({
      iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    this.yelloIcon = new L.Icon({
      iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-gold.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
  }


  async ngOnInit() {
    // this.ScrolltopService.setScrollTop();

    await this.services.getProvince().then((res: any) => {
      this.geo_province = res
      this.initMap(this.geo_province)
    });
    await this.services.get_all_funding().then((res: any) => {

      res.forEach((e: any) => {
        // if(e.status == 'Enable'){
        this.ena_projec.push(e)
        // console.log(this.ena_projec);

        // }
      });

      this.all_project = this.ena_projec
      // console.log(this.all_project);

      this.initchart(res)
    });

    // console.log(this.all_project);

    let data_province = this.all_project.reduce(function (r: any, row: any) {
      r[row.province] = ++r[row.province] || 1;
      return r;
    }, {});
    this.group_province = Object.keys(data_province).map(function (key) {
      return key
    }).sort()

    let data_year = this.all_project.reduce(function (r: any, row: any) {
      r[row.fund_year] = ++r[row.fund_year] || 1;
      return r;
    }, {});
    this.group_year = Object.keys(data_year).map(function (key) {
      return key
    }).sort()


    this.sum_project = this.all_project.length

    this.all_project_query = this.all_project
    // console.log(this.all_project_query);



    let arr_list_province = [] as any
    let arr_list_province_2 = [] as any
    let arr_list_province_3 = [] as any
    let arr_list_province_4 = [] as any
    this.all_project.forEach((e: any) => {
      if (e.type_money == 'เงินอุดหนุน' && e.status == 'Enable') {
        this.list_province.push({ name: e.province, value: e.amount_receive, type_money: e.type_money, id: e.project_key, project_id: e.project_id })
        arr_list_province.push(Number(e.amount_receive))
      } else if (e.type_money == 'เงินให้กู้ยืม' && e.status == 'Enable') {
        this.list_province_2.push({ name: e.province, value: e.amount_receive, type_money: e.type_money, id: e.project_key, project_id: e.project_id })
        arr_list_province_2.push(Number(e.amount_receive))

      } else if (e.type_money == 'เงินสนับสนุน' && e.status == 'Enable') {
        this.list_province_3.push({ name: e.province, value: e.amount_receive, type_money: e.type_money, id: e.project_key, project_id: e.project_id })
        arr_list_province_3.push(Number(e.amount_receive))

      } else if (e.type_money == 'เงินทดรองจ่าย' && e.status == 'Enable') {
        this.list_province_4.push({ name: e.province, value: e.amount_receive, type_money: e.type_money, id: e.project_key, project_id: e.project_id })
        arr_list_province_4.push(Number(e.amount_receive))

      }
    });

    // console.log(this.list_province);

    let count_prov = this.all_project.reduce(function (r: any, row: any) {
      r[row.province] = ++r[row.province] || 1;
      return r;
    }, {});
    count_prov = Object.keys(count_prov).map(function (key) {
      return key
    }).sort()

    this.count_prov = count_prov.length


    this.sum_budget = arr_list_province.reduce(function (a: any, b: any) {
      return a + b
    }, 0);
    this.sum_budget_2 = arr_list_province_2.reduce(function (a: any, b: any) {
      return a + b
    }, 0);
    this.sum_budget_3 = arr_list_province_3.reduce(function (a: any, b: any) {
      return a + b
    }, 0);
    this.sum_budget_4 = arr_list_province_4.reduce(function (a: any, b: any) {
      return a + b
    }, 0);

  }

  async initMap(geojson: any) {
    this.map = L.map('map', {
      attributionControl: false,
      center: [13.748431, 100.704130],
      zoom: 6
    });
    L.tileLayer('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', {
      maxZoom: 20
    }).addTo(this.map);

    var CityPlan_view = L.tileLayer('https://map.nostramap.com/NostraMap/proxy.ashx?https://mapdynamic.nostramap.com/arcgis/rest/services/CityPlan_view/MapServer/tile/{z}/{y}/{x}', {
      //tms: true,
      maxZoom: 19
      //attribution: '&copy; <a href="https://map.nostramap.com">NostraMap</a>'
    }).addTo(this.map);

    this.layer_marker = L.layerGroup().addTo(this.map)


    function style(feature: any) {
      return {
        fillColor: '#ff9900',
        weight: 3,
        opacity: 1,
        color: 'white',
        dashArray: '4',
        fillOpacity: 0
      };
    }
    function onEachFeature(feature: any, layer: any) {
      layer.bindPopup('จังหวัด : ' + feature.properties.pv_tn)
    }
    L.geoJSON(geojson, { style: style, onEachFeature: onEachFeature }).addTo(this.layer_marker)

    // L.Control.watermark = L.Control.extend({
    //   onAdd: function (map) {
    //     var img = L.DomUtil.create('img');
    //     img.src = 'https://pngimg.com/uploads/compass/compass_PNG25581.png';
    //     img.style.width = '85px';
    //     img.style.opacity = '0.8';
    //     return img;
    //   }
    // });
    // L.control.watermark = function (opts) {
    //   return new L.Control.watermark(opts);
    // }
    // L.control.watermark({
    //   position: 'bottomleft'
    // }).addTo(this.map);


    var legend = L.control.attribution({ position: 'bottomright' });

    legend.onAdd = function (map: any) {

      var div = L.DomUtil.create('div', 'info legend'),
        grades = [0, 10, 20, 50, 100, 200, 500, 1000],
        labels = [],
        from, to;

      labels.push(
        '   <tr class="table-active">\
                <td><img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png" alt="" width="10%"> </td>\
                <td> เงินให้กู้ยืม</td>\
              </tr> <br><tr class="table-active">\
                <td><img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png" alt="" width="10%"> </td>\
                <td> เงินอุดหนุน</td>\
              </tr> <br><tr class="table-active">\
                <td><img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png" alt="" width="10%"> </td>\
                <td> เงินสนับสนุน</td>\
              </tr> <br><tr class="table-active">\
                <td><img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-gold.png" alt="" width="10%"> </td>\
                <td> เงินทดรองจ่าย</td>\
              </tr>');

      div.innerHTML = labels.join('<br>');
      return div;
    };

    legend.addTo(this.map);
  }



  initchart(res: any) {
    // if(this.user.status == 'admin'){
    res.forEach((e: any) => {
      // console.log(e);

      if (e.type_money == 'เงินอุดหนุน') {
        L.marker([e.lat, e.lon], { icon: this.violetIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      } else if (e.type_money == 'เงินให้กู้ยืม') {
        L.marker([e.lat, e.lon], { icon: this.redIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      } else if (e.type_money == 'เงินสนับสนุน') {
        L.marker([e.lat, e.lon], { icon: this.greenIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      } else if (e.type_money == 'เงินทดรองจ่าย') {
        L.marker([e.lat, e.lon], { icon: this.yelloIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      }
    });

    let data_budget_year = res.reduce(function (r: any, row: any) {
      r[row.fund_year] = ++r[row.fund_year] || 1;
      return r;
    }, {});
    let group_year = Object.keys(data_budget_year).map(function (key) {
      return { year: key, count: data_budget_year[key], budget_1: 0, budget_2: 0, budget_3: 0, budget_4: 0 }
    }).sort();

    group_year.forEach((e: any) => {
      res.forEach((f: any) => {
        if (e.year == f.fund_year && f.type_money == 'เงินให้กู้ยืม') {
          e.budget_1 = e.budget_1 + Number(f.budget)
        } else if (e.year == f.fund_year && f.type_money == 'เงินอุดหนุน') {
          e.budget_2 = e.budget_2 + Number(f.budget)
        } else if (e.year == f.fund_year && f.type_money == 'เงินสนับสนุน') {
          e.budget_3 = e.budget_3 + Number(f.budget)
        } else if (e.year == f.fund_year && f.type_money == 'เงินทดรองจ่าย') {
          e.budget_4 = e.budget_4 + Number(f.budget)
        }
      });
    });

    group_year.forEach((e: any) => {
      this.xAxis_1.push(e.year)
      this.data_1.push(e.budget_1)
      this.data_2.push(e.budget_2)
      this.data_3.push(e.budget_3)
      this.data_4.push(e.budget_4)
    });
    this.EChartOption1 = {
      title: {
        text: '',
        subtext: ''
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['จำนวนเงินให้กู้ยืม', 'จำนวนเงินอุดหนุน', 'จำนวนเงินสนับสนุน', 'จำนวนเงินทดรองจ่าย'],
        fontFamily: 'Prompt'
      },
      toolbox: {
        show: true,
        feature: {
          dataView: { show: false, readOnly: false },
          magicType: { show: false, type: ['line', 'bar'] },
          restore: { show: false },
          saveAsImage: { show: false }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: this.xAxis_1
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'จำนวนเงิน',
          axisLabel: {
            formatter: ''
          }
        }
      ],
      series: [
        {
          name: 'จำนวนเงินให้กู้ยืม',
          type: 'bar',
          data: this.data_1,
          markPoint: {
            data: [
              { type: 'max', name: 'มากสุด' },
            ]
          },
          markLine: {
            data: [
              { type: 'average', name: 'เฉลี่ย' }
            ]
          }
        },
        {
          name: 'จำนวนเงินอุดหนุน',
          type: 'bar',
          data: this.data_2,
          markPoint: {
            data: [
              { type: 'max', name: 'มากสุด' },
            ]
          },
          markLine: {
            data: [
              { type: 'average', name: 'เฉลี่ย' }
            ]
          }
        },
        {
          name: 'จำนวนเงินสนับสนุน',
          type: 'bar',
          data: this.data_3,
          markPoint: {
            data: [
              { type: 'max', name: 'มากสุด' },
            ]
          },
          markLine: {
            data: [
              { type: 'average', name: 'เฉลี่ย' }
            ]
          }
        },
        {
          name: 'จำนวนเงินทดรองจ่าย',
          type: 'bar',
          data: this.data_4,
          markPoint: {
            data: [
              { type: 'max', name: 'มากสุด' },
            ]
          },
          markLine: {
            data: [
              { type: 'average', name: 'เฉลี่ย' }
            ]
          }
        }
      ]
    };


    res.forEach((e: any) => {
      if (e.type_money == 'เงินให้กู้ยืม') {
        this.value_chart_1 = this.value_chart_1 + Number(e.budget)
      } else if (e.type_money == 'เงินอุดหนุน') {
        this.value_chart_2 = this.value_chart_2 + Number(e.budget)
      } else if (e.type_money == 'เงินสนับสนุน') {
        this.value_chart_3 = this.value_chart_3 + Number(e.budget)
      } else if (e.type_money == 'เงินทดรองจ่าย') {
        this.value_chart_4 = this.value_chart_4 + Number(e.budget)
      }
    });
    let max_values = Math.max(this.value_chart_1, this.value_chart_2, this.value_chart_3, this.value_chart_4)
    let min_values = Math.min(this.value_chart_1, this.value_chart_2, this.value_chart_3, this.value_chart_4)
    this.EChartOption2 = {

      title: {
        text: '',
        left: 'center',
        top: 20,

      },

      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },

      legend: {
        textStyle: {
          fontSize: 12,
          fontFamily: 'Prompt'
        }
      },

      visualMap: {
        show: false,
        min: min_values / 10,
        max: max_values * 2,
        inRange: {
          colorLightness: [0, 1]
        }
      },
      series: [
        {
          name: 'สัดส่วนเงิน',
          type: 'pie',
          radius: '55%',
          center: ['50%', '50%'],

          data: [
            { value: this.value_chart_1, name: 'เงินให้กู้ยืม' },
            { value: this.value_chart_2, name: 'เงินอุดหนุน' },
            { value: this.value_chart_3, name: 'เงินสนับสนุน' },
            { value: this.value_chart_4, name: 'เงินทดรองจ่าย' }
          ].sort(function (a: any, b: any) { return a.value - b.value; }),
          roseType: 'radius',

          labelLine: {

            smooth: 0.2,
            length: 10,
            length2: 20
          },
          itemStyle: {
            textStyle: {
              fontSize: 12,
              fontFamily: 'Prompt'
            },
            color: '#c23531',
            shadowBlur: 200,
            shadowColor: 'rgba(0, 0, 0, 0)'
          },

          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: function (idx: any) {
            return Math.random() * 200;
          }
        }
      ]
    }
  }

  async search_project() {
    this.all_project_query = []
    this.all_project.forEach((e: any) => {
      if (
        e.project_name.match(this.name_project) &&
        e.type_money.match(this.type_money) &&
        e.province.match(this.select_province) &&
        e.fund_year.match(this.budget_year)
      ) {
        this.all_project_query.push(e)
      }
    });
    this.text_result = 'ผลการค้นหาทั้งหมด : ' + this.all_project_query.length + ' โครงการ'
  }
  refresh_list_project() {
    this.all_project_query = this.all_project
    this.text_result = ''
    this.type_money = ''
    this.name_project = ''
    this.select_province = ''
    this.budget_year = ''
  }

  async view_year(json: any) {
    this.year_start = json[0].fund_year
    this.year_end = json[json.length - 1].fund_year
  }



  async select_section(id: any) {
    this.layer_marker.clearLayers()
    this.section = id


    // if(this.user.status == 'admin'){
    this.all_project.forEach((e: any) => {
      // console.log(e);

      if (id == 2 && e.type_money == 'เงินอุดหนุน') {
        L.marker([e.lat, e.lon], { icon: this.violetIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      } else if (id == 3 && e.type_money == 'เงินให้กู้ยืม') {
        L.marker([e.lat, e.lon], { icon: this.redIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      } else if (id == 4 && e.type_money == 'เงินสนับสนุน') {
        L.marker([e.lat, e.lon], { icon: this.greenIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      } else if (id == 5 && e.type_money == 'เงินทดรองจ่าย') {
        L.marker([e.lat, e.lon], { icon: this.yelloIcon })
          .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
          .addTo(this.layer_marker)
      } else if (id == 1) {
        if (e.type_money == 'เงินอุดหนุน') {
          L.marker([e.lat, e.lon], { icon: this.violetIcon })
            .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
            .addTo(this.layer_marker)
        } else if (e.type_money == 'เงินให้กู้ยืม') {
          L.marker([e.lat, e.lon], { icon: this.redIcon })
            .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
            .addTo(this.layer_marker)
        } else if (e.type_money == 'เงินสนุบสนุน') {
          L.marker([e.lat, e.lon], { icon: this.greenIcon })
            .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
            .addTo(this.layer_marker)
        } else if (e.type_money == 'เงินทดรองจ่าย') {
          L.marker([e.lat, e.lon], { icon: this.yelloIcon })
            .bindPopup('<h4>ตำแหน่งที่ตั้งโครงการ</h4><hr> <h5> ' + e.project_name + '</h5></a>')
            .addTo(this.layer_marker)
        }
      }
    });




    this.geo_province.features.forEach((e: any) => {
      if (id == 2 && e.properties.type_money == 'เงินอุดหนุน') {
        L.geoJSON(e, { style: style, onEachFeature: onEachFeature }).addTo(this.layer_marker)
      } else if (id == 3 && e.properties.type_money == 'เงินให้กู้ยืม') {
        L.geoJSON(e, { style: style, onEachFeature: onEachFeature }).addTo(this.layer_marker)
      } else if (id == 4 && e.properties.type_money == 'เงินสนับสนุน') {
        L.geoJSON(e, { style: style, onEachFeature: onEachFeature }).addTo(this.layer_marker)
      } else if (id == 5 && e.properties.type_money == 'เงินทดรองจ่าย') {
        L.geoJSON(e, { style: style, onEachFeature: onEachFeature }).addTo(this.layer_marker)
      } else if (id == 1) {
        L.geoJSON(e, { style: style, onEachFeature: onEachFeature }).addTo(this.layer_marker)
      }
    });


    function style(feature: any) {
      return {
        fillColor: '#ff9900',
        weight: 3,
        opacity: 1,
        color: 'white',
        dashArray: '4',
        fillOpacity: 0
      };
    }
    function onEachFeature(feature: any, layer: any) {
      layer.bindPopup('จังหวัด : ' + feature.properties.pv_tn)
    }



  }


}
